import { useGetSession } from "@/api/auth/queries";
import { setUser } from "@sentry/react";
import { useEffect } from "react";

/*
 * SentryUserInitializer component
 * This component initializes the Sentry user context with the current session data.
 */
export const SentryUserInitializer = () => {
  /* Queries */
  const { data: session } = useGetSession();

  /* Effects */
  useEffect(() => {
    if (session?.user?.email) {
      setUser({
        id: session?.user?.id,
        email: session?.user?.email,
        username: session?.user?.firstName + " " + session?.user?.lastName,
        accountName: session?.account?.company,
        accountId: session?.account?.id,
        organizationId: session?.account?.organisation?.id,
        organizationName: session?.account?.organisation?.name,
        subscriptionId: session?.subscription?.id,
        productAccess: session?.productAccess,
        userRole: session?.role,
        userCases: session?.account?.useCases,
      });
    }
  }, [session]);

  /* Render */
  return null;
};
